<script>
import Data from "@/test/data_sample.js";
import Endpoints from "@/data/Endpoints.js";

export default {
  mixins: [Data, Endpoints],
  computed: {
    endpointsList(){
      return Endpoints;
    },
    samplesCompounds(){
      return (Data || {}).smileses || [];
    }
  },
  methods: {
    drawAtom(obj) {
      if (obj == null) return;
      let atom = [];
      if (obj.result || false) {
        let newSearch = {};
        for (let i = 0, l = obj.result.length; i < l; i++) {
          if (
            (obj.result[i].endpoint || false) &&
            (obj.result[i].analysis || false)
          ) {
            newSearch[obj.result[i].endpoint] = obj.result[i].analysis.reduce(
              (p, c) => {
                p[c.atomId] = c.value;
                return p;
              },
              {}
            );
          }
        }console.log(newSearch);
        let canonical = obj.canonical;
        atom = canonical.match(/[A-Z][a-z]|[A-Z]H|[A-Z]|[0-9]|\D/g);
        let str = '';
        let elIndex = 0;
          //put analysis
          if (newSearch[this.currentEp] || false) {
            for (let i = 0, l = atom.length; i < l; i++) {
              if (atom[i].match(/[A-Z][a-z]|[A-Z]H|[A-Z]/g)) {
                if (newSearch[this.currentEp][elIndex] != undefined) {
                  atom[i] =
                    '<i class="mark" data-id="' +
                    elIndex +
                    '">' +
                    atom[i] +
                    '</i>';
                } else {
                  atom[i] = '<i>' + atom[i] + '</i>';
                }
                elIndex++;
              }
            }
          } else {
            for (let i = 0, l = atom.length; i < l; i++) {
              if (atom[i].match(/[A-Z][a-z]|[A-Z]H|[A-Z]/g)) {
                atom[i] = '<i>' + atom[i] + '</i>';
                elIndex++;
              }
            }
          }
        //to str
        for (let i = 0, l = atom.length; i < l; i++) {
          str += atom[i];
        }
        atom = str;
      }
      return atom;
    },
    updateAnalysis(ep) {
        if (this.delayHandler) clearTimeout(this.delayHandler);
        this.delayHandler = setTimeout(() => {
          this.updateparent(
            ep,
           this.analysis[ep]
          );
          try {
            this.$refs.element.markerUpdate(1);
          } catch (error) {
            console.log(error);
          }
        }, 300);
    },
    updateparent(val, arr) {
      this.currentEp = val;
      this.atom = this.drawAtom(this.compoundA);
      try {
        this.$refs.element.markerShow(
          (arr || []).map(e => {
            return e.atomId.toString();
          })
        );
      } catch (error) {
        // console.log(error);
      }
    },
    getDisplayValue(r) {
      let v = (r || {}).value;
      switch ((r || {}).type) {
        case 'boolean':
          if ((r || {}).probability != undefined)
            return ((r || {}).probability * 100).toFixed(1) + '%';
          else return v ? 'Yes' : 'No';
        case 'float':
          return v.toFixed(2);
        case 'int':
          return v;
        case 'string':
          return v;
        default:
          return '---';
      }
    },
    getDisplayValueOrigin(r) {
      let v = (r || {}).value;
      switch ((r || {}).type) {
        case 'boolean':
          return v ? 'Yes' : 'No';
        case 'float':
          return v.toFixed(2);
        case 'int':
          return v;
        case 'string':
          return v;
        default:
          return '---';
      }
    },
    getDisplayUnit(ep) {
      let r = ep.result;
      if (!r) {
        return '---';
      }
      let u = r.unit;
      if (!u) {
        return '---';
      }
      return u;
    },
    ivData(c, v, d) {
      return {
        clearance: c,
        vod: v,
        dose: d
      };
    }
  }
};
</script>
